import type { ApiKeyMetadata as GeneratedApiKeyMetadata } from "@sakura-tech-lab/dashboard-api";

import { apiKeysApi } from "@/services/dashboard-api.client";

export type ApiKeyMetadata = GeneratedApiKeyMetadata;

export const ApiKeyService = {
  getAll: async (): Promise<ApiKeyMetadata[]> => {
    const response = await apiKeysApi.listApiKeys();
    return response.data;
  },

  create: async (name: string): Promise<string> => {
    const response = await apiKeysApi.createApiKey({ apiKeyCreate: { name } });
    const rawKey = response.data.key;

    if (typeof rawKey !== "string" || rawKey.length === 0) {
      throw new Error("API key creation response did not include the raw key");
    }

    return rawKey;
  },

  delete: async (id: string): Promise<void> => {
    await apiKeysApi.deleteApiKey({ id });
  },

  toggleEnabled: async (id: string, enabled: boolean): Promise<void> => {
    await apiKeysApi.updateApiKey({ id, apiKeyUpdate: { enabled } });
  },
};
